import axios from 'axios'
import settings from '@/settings.js'

export default {
  namespaced: true,
  state: {
    list: [],
  },

  getters: {
    list: state => {
      return state.list;
    },
  },

  actions: {
    async getList({commit, rootState} ) {
      let list = await axios.get(`${settings.APP_SERVICE_URL}rest/examination/places-and-types`, {
        headers: {
          Authorization: `Bearer ${rootState.auth.token}`
        }
      });
      commit('SET_LIST', list.data)
    },
  },

  mutations: {
    SET_LIST(state, list) {
      state.list = list;
    },
  },
};
